import Flatpickr from "stimulus-flatpickr";
import { Slovenian } from "flatpickr/dist/l10n/sl.js";

export default class extends Flatpickr {

  connect() {
    this.config = {
      locale: Slovenian,
      prevArrow: "<i class='ei ei-arrow_left'></i>",
      nextArrow: "<i class='ei ei-arrow_right'></i>",
      monthSelectorType: "static"
    };

    super.connect();
  }

  ready(selectedDates, dateStr, instance) {
    var urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('date'))
      instance.setDate(urlParams.get('date'))
  }

  change(selectedDates, dateStr, instance) {
    let daily_sheet_id = instance.selectedDateElem.dataset.dailySheetId
    let url = (daily_sheet_id) ? `${daily_sheet_id}/edit` : `new?date=${dateStr}`
    Turbolinks.visit(`/building_logs/${this.buildingLogId}/daily_sheets/${url}`)
  }

  dayCreate(dObj, dStr, fp, dayElem) {
    this.dailySheetsDates.forEach(el => {
      if (new Date(el.date).setHours(0,0,0,0) === dayElem.dateObj.setHours(0,0,0,0)) {
        dayElem.setAttribute('data-daily-sheet-id', el.id)
        dayElem.innerHTML += `<span class='event busy'></span>`;
      }
    });
  }

  get dailySheetsDates() {
    return JSON.parse(this.data.get("dailySheetsDates"))
  }

  get buildingLogId() {
    return this.data.get("buildingLogId")
  }

}
